<mat-toolbar  class="navbar" [class.collapsed]="collapsed">

    <button class="skip-to-main-content" mat-flat-button (click)="skipToMainContent()">
        Skip to main content
    </button>

    <a class="logo" style="text-decoration: none; color: var(--mat-sys-on-surface)" routerLink="/">Jar.games</a>
    <span class="spacer"></span>
    
    <!-- Desktop Navigation -->
    <div class="desktop-nav">
        @if (isAdmin) {
            <button mat-button (click)="navigate('/admin')">Admin</button>
        }
        <!--
        <button mat-button (click)="navigate('/worlds')">Worlds</button>
        -->
        <button mat-button (click)="navigate('/patreon')">Patreon</button>
        <button mat-button (click)="navigate('/help')">Help</button>
        @if (accountService.account.value) {
            
            <button mat-icon-button [matMenuTriggerFor]="userMenu" class="avatar-button">
                <app-avatar class="avatar-img" [src]="accountService.account.value.connections.discord?.avatar" alt=""></app-avatar>
            </button>
            <mat-menu #userMenu="matMenu">
                <button mat-menu-item (click)="navigate('/account')">
                    <mat-icon>settings</mat-icon>
                    <span>Account Settings</span>
                </button>
                <button mat-menu-item (click)="navigate('/notifications')">
                    <mat-icon>notifications</mat-icon>
                    <span>Notifications</span>
                </button>
                <button mat-menu-item (click)="logout()">
                    <mat-icon>logout</mat-icon>
                    <span>Logout</span>
                </button>
            </mat-menu>
        } @else {
            <button mat-flat-button (click)="navigate('/login')">
                <mat-icon>login</mat-icon>
                <span>Login</span>
            </button>
        }
    </div>

    <!-- Mobile Navigation -->
    <div class="mobile-nav">
        <button mat-icon-button (click)="toggleMenu()" class="menu-button">
            <mat-icon>{{ isMenuOpen ? 'close' : 'menu' }}</mat-icon>
        </button>
        
        <div class="mobile-menu" [class.open]="isMenuOpen">
            @if (isAdmin) {
                <div class="mobile-menu-item">
                    <button mat-button (click)="navigate('/admin')">Admin</button>
                </div>
            }
            <!--
            <div class="mobile-menu-item">
                <button mat-button (click)="navigate('/worlds')">Worlds</button>
            </div>
            -->
            <div class="mobile-menu-item">
                <button mat-button (click)="navigate('/patreon')">Patreon</button>
            </div>
            <div class="mobile-menu-item">
                <button mat-button (click)="navigate('/help')">Help</button>
            </div>
            @if (accountService.account.value) {
                <div class="mobile-menu-item" style="width: fit-content; align-self: flex-end; gap: 10px">
                
                    <button mat-icon-button style="width: fit-content;" (click)="navigate('/account')">
                        <mat-icon>manage_accounts</mat-icon>
                    </button>
                    <button mat-icon-button style="width: fit-content;" (click)="logout(); navigate('/')">
                        <mat-icon>logout</mat-icon>
                    </button>

                </div>
            } @else {
                <div class="mobile-menu-item" style="width: fit-content; align-self: flex-end;">
                    <button mat-flat-button (click)="navigate('/login')">
                        <mat-icon>login</mat-icon>
                        <span>Login</span>
                    </button>
                </div>
            }
        </div>
    </div>
</mat-toolbar>